export default __webpack_public_path__ + "static/culture-2-b38297c9d5418cd2b4cdb2342e160a65.jpg";